import axios from "axios";

const BASE_PATH = process.env.VUE_APP_API_BASE_URL;
const API_KEY = process.env.VUE_APP_API_KEY;

export const API_URL = `${BASE_PATH}/api-dep/`;

const knAxios = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
  },
});
knAxios.interceptors.request.use(
  (config) => {
    if (config.headers["No-Auth"] == "true") {
      delete config.headers["No-Auth"];
      return config;
    }

    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export const knAuthAxios = axios.create({
  baseURL: BASE_PATH,

  headers: {
    "Content-Type": "application/json",
    apikey: API_KEY,
    "Access-Control-Allow-Origin": "*",
    "Access-Control-Allow-Methods": "GET, POST, PATCH, PUT, DELETE, OPTIONS",
    "Access-Control-Allow-Headers": "Origin, Content-Type, X-Auth-Token",
  },
});

export default knAxios;
